import * as React from "react";
// @ts-ignore
import {NostoPlacement, NostoProvider, NostoProduct} from "@nosto/nosto-react"

export const NostoRecommendations = ({ placement_id }) => {
    console.log('Loading Nosto Recommendations for Placement ID: ' + placement_id);

    return (
        <>
            <NostoProvider shopifyMarkets={false} account="shopify-23745462352" recommendationComponent={<NostoSlot nostoRecommendation={undefined} />}>
            </NostoProvider>
            <NostoPlacement id={placement_id}/>
            Hello Nosto: {placement_id}
        </>
    )
}

export function NostoItem({product, onClick}) {
    return (
        <div className="nosto-item" onClick={onClick}>
            <a href={product.url}>
                <div className="nosto-image-container">
                    <div className="nosto-image">
                        <img src={product.thumb_url} alt={product.name} />
                    </div>
                    <div className="nosto-product-details">
                        <div className="nosto-product-name">{product.name}</div>
                        <div className="nosto-product-price">{product.price_text}</div>
                    </div>
                </div>
            </a>
        </div>
    );
}

export function NostoSlot({ nostoRecommendation }) {
    // This doesn't load
    console.log("NostoSlot Loaded!");
    console.log(nostoRecommendation)

    let { title, products, result_id } = nostoRecommendation;

    function reportClick(productId) {
        // To report attribution for product clicks towards segmentation & analytics
        window?.nostojs(function(api) {
            // @ts-ignore
            api.defaultSession().recordAttribution('vp', productId, result_id).done();
        });
    }

    return (
        <div className="nosto-container">
            <h2 className="nosto-title">{title}</h2>
            <div className="nosto-list">
                {products.map((product) => (
                    <NostoItem
                        product={product}
                        key={product.product_id}
                        onClick={() => {
                            reportClick(product.product_id);
                        }}
                    />
                ))}
            </div>
        </div>
    );
}

export default NostoRecommendations;